<div class="progress-wrapper">
    <span class="inner-text">{{value}} of {{maxValue}} {{text}}</span>
    <svg viewBox="0 0 100 100" preserveAspectRatio="xMinYMin meet">
        <g transform="rotate(-90, 50, 50) translate(50, 50)">
          <circle class="progress-bg" [attr.r]="radius"></circle>
          <circle class="progress"  [attr.r]="radius" [ngStyle]="{ 'stroke-dashoffset': stroke,  'stroke-dasharray': diameter }" ></circle>
        </g>
    </svg>
</div>
